const menuList = [
  { id: 0, name: '首页', routerUrl: '/' },
  { id: 1, name: '关于神漫', routerUrl: '/about' },
  { id: 2, name: '神漫出品', routerUrl: '/products' },
  { id: 3, name: '技术优势', routerUrl: '/technical' },
  { id: 4, name: '招贤纳士', routerUrl: '/invite' },
  { id: 5, name: '神漫资讯', routerUrl: '/realtime' },
  { id: 6, name: '联系我们', routerUrl: '/contact' }
]

export default {menuList}



// WEBPACK FOOTER //
// ./src/util/info.js